module.exports = __webpack_public_path__ + "img/regular4.7fc285cd.jpg";